"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Announcement = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var Announcement = function (_a) {
    var actionName = _a.actionName, className = _a.className, onActionClick = _a.onActionClick, onClose = _a.onClose, _b = _a.status, status = _b === void 0 ? 'info' : _b, title = _a.title, props = __rest(_a, ["actionName", "className", "onActionClick", "onClose", "status", "title"]);
    var critical = status === 'critical';
    var warning = status === 'warning';
    var info = status === 'info';
    var AnnouncementClasses = classnames_1.default('Announcement', className, {
        'Announcement--critical': critical,
        'Announcement--warning': warning,
        'Announcement--info': info,
    });
    return (react_1.default.createElement("div", __assign({ className: AnnouncementClasses }, props),
        react_1.default.createElement("div", { className: "Announcement__body" },
            react_1.default.createElement("div", { className: "Announcement__title" }, title),
            actionName && onActionClick && (react_1.default.createElement(__1.Button, { small: true, className: "Announcement__action", onClick: onActionClick }, actionName))),
        onClose && (react_1.default.createElement(__1.Button, { fill: warning ? 'subtle' : 'solid', color: info ? 'blue' : critical ? 'red' : null, className: "Announcement__close", iconName: "clear", size: "xsmall", onClick: onClose }))));
};
exports.Announcement = Announcement;
//# sourceMappingURL=Announcement.js.map